import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormControlOption } from '../../definition/interface/formControlOption.interface';
import { InfoOption } from '../info/info.component';

@UntilDestroy()
@Component({
    selector: 'beneficiary-clause-beneficiaire',
    templateUrl: './beneficiary-clause-beneficiaire.component.html',
    styleUrls: ['./beneficiary-clause-beneficiaire.component.scss'],
    standalone: false
})
export class BeneficiaryClauseBeneficiaireComponent
  implements OnInit, OnChanges
{
  beneficiaryClauseBeneficiaireForm: UntypedFormArray;

  options: FormControlOption[] = [
    { value: 'M', label: 'Mr', suffix: { title: 'A' } },
    { value: 'F', label: 'Mme', suffix: { title: 'B' } },
  ];
  error: ValidationErrors = null;
  @Input() derrors: any = undefined;
  @Input() formGroup: UntypedFormGroup;
  countries: any[];

  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };

  constructor(private referenceDao: ReferenceDao) {}

  ngOnInit() {
    this.beneficiaryClauseBeneficiaireForm = this.formGroup.get(
      'avClauseBeneficiaireBeneficiaires',
    ) as UntypedFormArray;

    this.formGroup
      .get('avClauseBeneficiaireBeneficiaires')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(() => {
        this.error = this.formGroup.get(
          'avClauseBeneficiaireBeneficiaires',
        ).errors;
      });

    this.referenceDao.getCountries().subscribe(countries => {
      this.countries = countries;
    });
  }

  addFields() {
    this.beneficiaryClauseBeneficiaireForm.push(
      new UntypedFormGroup({
        civility: new UntypedFormControl(null),
        firstName: new UntypedFormControl('', [Validators.required]),
        lastName: new UntypedFormControl('', [Validators.required]),
        maidenName: new UntypedFormControl(''),
        email: new UntypedFormControl(''),
        birthDate: new UntypedFormControl(null),
        phone: new UntypedFormControl(''),
        percentage: new UntypedFormControl(100, [Validators.required]),
        address: new UntypedFormGroup({
          street: new UntypedFormControl('', [Validators.required]),
          street2: new UntypedFormControl(''),
          zipCode: new UntypedFormControl('', [Validators.required]),
          city: new UntypedFormControl('', [Validators.required]),
          country: new UntypedFormControl(''),
        }),
      }),
    );

    this.beneficiaryClauseBeneficiaireForm.markAsUntouched();
  }

  deleteFields(index) {
    this.beneficiaryClauseBeneficiaireForm.removeAt(index);
  }

  ngOnChanges() {
    if (this.beneficiaryClauseBeneficiaireForm)
      this.beneficiaryClauseBeneficiaireForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
